var _path, _path2, _g, _path3, _path4, _path5, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBankApplepay = function SvgBankApplepay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 24,
    viewBox: "0 0 57 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7333 2.98847C11.3608 2.18383 11.7868 1.10372 11.6743 0C10.7559 0.0467445 9.63466 0.62084 8.98549 1.42639C8.40274 2.11576 7.8873 3.24126 8.02148 4.29868C9.0528 4.39036 10.0832 3.77042 10.7333 2.98847Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1561_3165",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.70346H15.7316V19.2378H0V4.70346Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1561_3165)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.694 4.70978C10.1025 4.61561 8.74907 5.60442 7.98907 5.60442C7.2286 5.60442 6.06484 4.75734 4.80601 4.77971C3.16743 4.80396 1.64696 5.72144 0.815426 7.18111C-0.894691 10.1014 0.364132 14.4329 2.02719 16.811C2.83472 17.9876 3.80837 19.2832 5.09072 19.2366C6.30248 19.19 6.77731 18.4594 8.25025 18.4594C9.72225 18.4594 10.15 19.2366 11.4328 19.2128C12.7627 19.19 13.5947 18.0361 14.4022 16.8585C15.3288 15.5172 15.7077 14.2217 15.7317 14.1508C15.7077 14.127 13.1665 13.1615 13.1434 10.2655C13.119 7.84079 15.1382 6.68787 15.2333 6.61608C14.0931 4.94522 12.3114 4.75734 11.694 4.70978Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7902 10.6546H24.9036C27.2662 10.6546 28.6108 9.35632 28.6108 7.10506C28.6108 4.85427 27.2662 3.56824 24.9156 3.56824H21.7902V10.6546ZM25.6308 1.23077C29.0229 1.23077 31.3846 3.6177 31.3846 7.09281C31.3846 10.5802 28.9745 12.9798 25.5459 12.9798H21.7902V19.0769H19.0769V1.23077H25.6308Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0282 14.5705V13.5387L37.819 13.7376C36.2205 13.8498 35.3158 14.5582 35.3158 15.6772C35.3158 16.8208 36.2583 17.5666 37.6953 17.5666C39.5656 17.5666 41.0282 16.2738 41.0282 14.5705ZM32.6154 15.7515C32.6154 13.4639 34.362 12.0589 37.4598 11.8851L41.0282 11.6739V10.6667C41.0282 9.21242 40.0494 8.34206 38.4141 8.34206C36.8652 8.34206 35.8986 9.08788 35.6632 10.2566H33.1354C33.2846 7.89409 35.2917 6.15384 38.5132 6.15384C41.6724 6.15384 43.6923 7.83206 43.6923 10.4555V19.4688H41.1273V17.318H41.0655C40.3099 18.7727 38.6614 19.6923 36.9515 19.6923C34.3993 19.6923 32.6154 18.1012 32.6154 15.7515Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1561_3165",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 6,
    width: 13,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3921 6.19577H56.9325V24H44.3921V6.19577Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1561_3165)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6988 23.9386V21.7806C45.8993 21.8299 46.3516 21.8299 46.578 21.8299C47.8344 21.8299 48.5131 21.3119 48.9276 19.9805C48.9276 19.9561 49.1664 19.1915 49.1664 19.1788L44.3921 6.19577H47.3319L50.6746 16.7499H50.7249L54.0676 6.19577H56.9327L51.9813 19.8448C50.8508 22.989 49.5436 24.0001 46.8049 24.0001C46.578 24.0001 45.8993 23.9752 45.6988 23.9386Z",
    fill: "black"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBankApplepay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bank-applepay.329c938be2f9a48f2372836c5fb31f7b.svg";